import { ICompanySpot } from "./../data/company";
import { IInquiry } from "pages/InquiryBoxList/InquiryBoxList";
import { atom } from "recoil";
import { ICompanyCategory } from "store/data/company";
import {
  ICompanyEvent,
  ICompanyLocationFilter,
  IWeddingHallFilter,
} from "store/data/data";
import { ISelect } from "pages/SelectSpotPage/SelectSpotPage";

export const companyCategoryState = atom<ICompanyCategory[]>({
  key: "companyCategoryState",
  default: [],
});

export const companyLocationFilterState = atom<ICompanyLocationFilter[]>({
  key: "companyLocationFilterState",
  default: [],
});

export const companyWeddingFilterState = atom<IWeddingHallFilter>({
  key: "companyWeddingFilterState",
  default: {},
});

export const companyEventListState = atom<ICompanyEvent[]>({
  key: "companyEventListState",
  default: [],
});

export const recombinationListState = atom<IInquiry[]>({
  key: "recombinationListState",
  default: [],
});

export const etcRecombinationListState = atom<IInquiry[]>({
  key: "etcRecombinationListState",
  default: [],
});

export type TSelectType = "weddingSuit" | "bridalParentalWear" | "parentsWear";

export interface ISelectList {
  no: number;
  title: string;
  type: TSelectType;
}

interface ISelectCloths {
  category: string;
  list: ISelectList[];
}

export interface ISelectlist {
  spotCheckData: ISelect[];
  spotList?: ICompanySpot[];
  clothesCheckData: ISelect[];
}
export const selectListState = atom<ISelectlist>({
  key: "selectListState",
  default: {
    spotCheckData: [],

    clothesCheckData: [],
  },
});
